// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconShare = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      d="M21 9.75v12c0 1.24-1.01 2.25-2.25 2.25H5.25C4.01 24 3 22.99 3 21.75v-12C3 8.51 4.01 7.5 5.25 7.5h1.5c.41 0 .75.34.75.75S7.16 9 6.75 9h-1.5c-.41 0-.75.34-.75.75v12c0 .41.34.75.75.75h13.5c.41 0 .75-.34.75-.75v-12c0-.41-.34-.75-.75-.75h-1.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1.5C19.99 7.5 21 8.51 21 9.75zM8.78 5.03l2.47-2.47v8.69c0 .41.34.75.75.75s.75-.34.75-.75V2.56l2.47 2.47c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06L12.53.22a.776.776 0 00-.24-.16.707.707 0 00-.57 0c-.09.04-.17.09-.24.16L7.73 3.97c-.29.29-.29.77 0 1.06.29.29.75.29 1.05 0z"
      fill="currentColor"
    />
  );
export default SvgIconShare;
